module.exports = __webpack_public_path__ + "muli-bold-webfont.asset.41f4b178099f07b5728a8fa7600f8ac7.woff";